export default [
  {
    path: '/customer-types',
    name: 'customer-types',
    component: () =>
      import(
        /* webpackChunkName: "customer-types" */ '@/view/pages/customer-type/CustomerType.vue'
      ),
    children: [
      {
        path: '/',
        name: 'list-customer-type',
        component: () =>
          import(
            /* webpackChunkName: "customer-types-list" */ '@/view/pages/customer-type/CustomerTypeList.vue'
          ),
        meta: {
          title: 'Danh sách loại khách hàng - Clickbuy',
        },
      },
    ],
  },
];
